import { useContext } from 'react';
import { SectorizationChartsDataContext } from '../contexts/SectorizationChartsDataContext';

export const useSectorizationChartsDataContext = () => {
    return useContext(SectorizationChartsDataContext);
};
